//@flow strict
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useSelector} from 'react-redux';

import {selectApplicantInformation} from 'src/selectors/crm';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import CollapsibleChipList from 'src/components/crm/lib/components/collapsible-chip-list/collapsible-chip-list.jsx';
import css from './skills-card.css';


const SkillsCard = (): React.Node => {
  const applicantDetails = useSelector(selectApplicantInformation);
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const skills = applicantDetails.resume?.skills || [];

  return (
    <>
      <Card
        classNames={{
          wrapper: css.card,
        }}
      >
        <CardHeader>
          <CardTitle className={css.cardTitleContainer}>
            <SemanticIcon name="lightbulb-on" type="solid" size="small" />
            {t('Skills', 'Skills')}
          </CardTitle>
        </CardHeader>
        <CardContent className={css.skillsCardContent}>
          {skills.length === 0 ? (
            <EmptyState
              description={t('No_skills_found', 'No skills found')}
              imageVariant="data"
            ></EmptyState>
          ) : (
            <CollapsibleChipList chipTextList={skills} />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default SkillsCard;
